import { get, post } from "@/utils";

export const LOGIN = (params = {}) => new Promise(async (resolve, reject) => {
  try {
    const res = await post('/users/login', params)
    resolve(res)
  } catch (error) {
    reject(error)
  }
})
export const GET_USERINFO = () => new Promise(async (resolve, reject) => {
  try {
    const res = await get('/users/info')
    resolve(res)
  } catch (error) {
    reject(error)
  }
})


export const GET_PHONECODE = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/users/sms", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})

export const GET_EMAILCODE = (params) => new Promise(async (resolve, reject) => {
  try {
    const res = await get("/users/email/get", params);
    resolve(res)
  } catch (error) {
    reject(error)
  }
})